import { ClipboardModule } from '@angular/cdk/clipboard';
import { CommonModule, DatePipe, isPlatformBrowser } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { Component, computed, effect, inject, OnDestroy, OnInit, PLATFORM_ID, Renderer2, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { faFacebook, faLinkedin, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import { faBookmark as faBookmarkRegular } from '@fortawesome/free-regular-svg-icons';
import { faBookmark as faBookmarkSolid, faCalendar, faCircleQuestion, faCreditCard, faCrown, faLink, faLock, faSquareCheck, faUserGroup } from '@fortawesome/free-solid-svg-icons';
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { DateTime } from 'luxon';
import { ReCaptchaV3Service } from 'ngx-captcha';
import { AccordionModule } from 'primeng/accordion';
import { MenuItem } from 'primeng/api';
import { BreadcrumbModule } from 'primeng/breadcrumb';
import { ButtonModule } from 'primeng/button';
import { GalleriaModule } from 'primeng/galleria';
import { InputGroupModule } from 'primeng/inputgroup';
import { InputNumberModule } from 'primeng/inputnumber';
import { MessageModule } from 'primeng/message';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SelectModule } from 'primeng/select';
import { TableModule } from 'primeng/table';
import { TabsModule } from 'primeng/tabs';
import { TextareaModule } from 'primeng/textarea';
import { catchError, distinctUntilChanged, EMPTY, finalize, Subscription, tap } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { IAskAQuestionRequest } from '../../../models/IAskAQuestionRequest';
import { IBiddingRequest } from '../../../models/IBiddingRequest';
import { ICustomMenuItem } from '../../../models/ICustomMenuItem';
import { IFeeRequest } from '../../../models/IFeeRequest';
import { IItemBidHistory } from '../../../models/IItemBidHistory';
import { IItemDetails } from '../../../models/IItemDetails';
import { ILineItems } from '../../../models/ILineItems';
import { ITieDetails } from '../../../models/ITieDetails';
import { AbsoluteMediaUriService } from '../../../services/absolute-media-uri.service';
import { ApiService } from '../../../services/api.service';
import { AuthService, LOGIN_TYPE_BID_INLINE, LOGIN_TYPE_TICKETS, LOGIN_TYPE_TOPBAR } from '../../../services/authentication/auth.service';
import { BidService } from '../../../services/bidding/bid.service';
import { CustomBreadcrumbService } from '../../../services/custom-breadcrumb/custom-breadcrumb.service';
import { DateFormatService } from '../../../services/date-format/date-format.service';
import { EmbeddedPaymentService } from '../../../services/epf/embedded-payment.service';
import { FavoritesItemsService } from '../../../services/favorites/favorites-items.service';
import { ModalService } from '../../../services/modals/modal.service';
import { RecaptchaLoaderService } from '../../../services/recaptcha-loader.service';
import { ThemeService } from '../../../services/theme.service';
import { ToastMessageService } from '../../../services/toast-message/toast-message.service';
import { CaptionBidPipe } from '../../../shared/pipes/caption-bid-history/caption-bid.pipe';
import { SanitizeHtmlTextPipe } from '../../../shared/pipes/sanitize-html-text.pipe';
import { DonorsComponent } from '../../auctions/donors/donors.component';
import { CreditCardInformationComponent } from '../../authentication/credit-card-information/credit-card-information.component';
import { SignInComponent } from '../../authentication/sign-in/sign-in.component';
import { BelowReserveBidComponent } from '../../bid-history-modals/below-reserve-bid/below-reserve-bid.component';
import { BelowReserveComponent } from '../../bid-history-modals/below-reserve/below-reserve.component';
import { ReserveMetComponent } from '../../bid-history-modals/reserve-met/reserve-met.component';
import { StraightBidComponent } from '../../bid-history-modals/straight-bid/straight-bid.component';
import { TieBidComponent } from '../../bid-history-modals/tie-bid/tie-bid.component';
import { EmbeddedPaymentComponent } from '../../embedded-payment/embedded-payment.component';
import { GalleryFullImageComponent } from "../../gallery-full-image/gallery-full-image.component";
import { AbsenteeBiddingComponent } from '../../items/absentee-bidding/absentee-bidding/absentee-bidding.component';
import { BiddingQuestionMarkComponent } from '../../items/bidding-question-mark/bidding-question-mark.component';
import { CustomBreadcrumbComponent } from '../custom-breadcrumb/custom-breadcrumb.component';

@Component({
  selector: 'app-item-details-bc',
  imports: [BreadcrumbModule,
    GalleriaModule,
    SanitizeHtmlTextPipe,
    FontAwesomeModule,
    SelectModule,
    FormsModule,
    CommonModule,
    InputGroupModule,
    InputNumberModule,
    ButtonModule,
    EmbeddedPaymentComponent,
    TabsModule,
    AccordionModule,
    TextareaModule,
    DonorsComponent,
    SignInComponent,
    RadioButtonModule,
    TableModule,
    CaptionBidPipe,
    RouterModule,
    BiddingQuestionMarkComponent,
    TieBidComponent,
    ReserveMetComponent,
    BelowReserveBidComponent,
    StraightBidComponent,
    RouterModule,
    CustomBreadcrumbComponent,
    MessageModule,
    ProgressSpinnerModule,
    GalleryFullImageComponent,
    AbsenteeBiddingComponent,
    ClipboardModule,
  ],
  providers: [DatePipe],
  templateUrl: './item-details-bc.component.html',
  styleUrl: './item-details-bc.component.scss'
})
export class ItemDetailsBcComponent implements OnInit, OnDestroy {

  errorLoadItemById: boolean = false;
  itemModal?: IItemDetails | null = null;
  idItemDetails: number = 0;
  itemMinimunBid!: number;
  itemMaximunBid!: number;
  quantity: number = 1;
  auctionId: number | null = 0;
  postBiddingLoading: boolean = false;
  errorLoadingBidHistory: boolean = false;
  postBiddingError: boolean = false;

  protected creditCardErrorMessage = '';

  iconUserGroup = faUserGroup;
  iconCalendar = faCalendar;
  faCircleQuestion = faCircleQuestion;
  faSquareCheck = faSquareCheck;
  faLock = faLock;
  faCreditCard = faCreditCard;
  faCrown = faCrown;
  faLink = faLink;
  faFacebook = faFacebook;
  faLinkedin = faLinkedin;
  faXTwitter = faXTwitter;

  // Tabs
  filteredTab: { value: number, title: string }[] = [];
  tabs = [
    { value: 0, title: 'Item Details' },
    { value: 1, title: 'Ask a question' },
    { value: 2, title: 'FAQ' },
    { value: 3, title: 'Bid History' }
  ];
  activeTab: number = 0;
  faqs = [
    { question: 'How to Login / Register as a Bidder', answer: 'To participate in bidding, you need to register and sign in as a bidder. In the top-right corner, select either "Sign In" or "Register" and complete the form. If you forget your password, use the "Forgot Password" link from the "Sign In" screen.', value: '0' },
    { question: 'Contacting the Organization hosting the Event/Auction', answer: 'For questions or assistance, go to "Contact Us" in the footer. Another option is on the item’s page, select the "Ask a question" tab and fill out the form to contact the hosting organization directly.', value: '1' },
    { question: 'How to Add/Edit/Remove Credit Card Information', answer: 'To manage your credit card details, sign into your bidder account, select "Welcome, (your name)" in the header and then select "Credit Cards".', value: '2' },
    { question: 'Types of Bidding - Straight Bidding vs. Proxy Bidding', answer: 'Straight Bidding involves placing a bid at a specific amount. Proxy Bidding allows the system to bid on your behalf up to a Maximum Bid Amount you set.  The system will automatically increase your bid as needed to maintain your leading position up to that maxmimum amount.', value: '3' },
    { question: 'How to Request a Bid Retraction', answer: 'To retract a bid, contact the hosting organization directly. On the item’s page, select "Ask a question" to request a bid retraction. BiddingForGood cannot process bid retraction requests from bidders.', value: '4' },
  ];

  //gallery
  selectedImage!: string;
  gallery: string[] = [];


  // bidProcess
  selectedBid: string = '';
  public bidPlaceholder = '';
  showLowBidError: boolean = false;
  showBidStatus: boolean = false;
  showBidError: boolean = false;
  showConfirmTemplate: boolean = false;
  selectedCardId: number | 0 = 0;
  userName!: string;
  formatPlacedOnDate: string | null = '';
  coverFeeConfirm: boolean = false;
  private readonly biddingService = inject(BidService);
  errorMessage: string | null = null;
  showMaxBidError: boolean = false;
  myBidLabel!: string;



  displayQuestionModal = false;

  //Bid history Modals
  displayStraigthBidModal: boolean = false;
  displayBelowReserveBidModal: boolean = false;
  displayReserveExplanationBidModal: boolean = false;
  displayReserveMetBidModal: boolean = false;
  displayTieWinBidModal: boolean = false;
  activeCaption: string | null = null;
  tieDetails: ITieDetails | null = null;
  bidResponseSignal = signal<string | null>(null);

  displayAbsenteeBiddingModal = false;



  //resolve items type
  itemType: 'buy' | 'bid' | 'buy-bid' | 'event' | 'upcoming' | 'closed' | 'sold' = 'event';
  selectedBidOption: 'STRAIGHT' | 'PROXY' = 'PROXY';
  formatBidHistory: IItemBidHistory[] = [];


  //Ask a question
  askAQuestionControl: string = '';
  userEmail!: string;
  responseError!: string;

  protected readonly absoluteMediaUriService = inject(AbsoluteMediaUriService);

  //favorites
  faBookmarkSolid = faBookmarkSolid;
  faBookmarkRegular = faBookmarkRegular;
  isFavorited: boolean = false;
  private readonly favoriteService = inject(FavoritesItemsService);

  //authentication process
  authService = inject(AuthService);
  private readonly oidcSecurityService = inject(OidcSecurityService);
  isAuthenticated = this.oidcSecurityService.authenticated;
  isShowingLoginIframe = signal(false);
  loginPage = LOGIN_TYPE_BID_INLINE;
  loginUrl = signal('');
  authSubscription!: Subscription;

  //embeddedPayment
  paymentService = inject(EmbeddedPaymentService);
  token: string = '';
  visibleEmbedded: boolean = false;
  feeSignal = this.paymentService.feeSignal;

  //formate date service
  private readonly dateFormatService = inject(DateFormatService);

  //reCAPTCHA
  private readonly recaptchaV3Service = inject(ReCaptchaV3Service);
  private readonly recaptchaLoader = inject(RecaptchaLoaderService);

  //api message service
  private readonly messageService = inject(ToastMessageService);

  private readonly route = inject(Router);
  // breadcrumb
  private readonly customBreadcrumbService = inject(CustomBreadcrumbService);
  itemsBreadcrumb: ICustomMenuItem[] | undefined;
  home!: MenuItem;
  responsiveOptions: any[] = [
    {
      breakpoint: '1300px',
      numVisible: 4
    },
    {
      breakpoint: '575px',
      numVisible: 3
    }
  ];

  private readonly apiService = inject(ApiService);
  private readonly modalService = inject(ModalService);

  private readonly platformId = inject(PLATFORM_ID);


  itemDetailsSingalModal = this.apiService.itemDetailSignal;
  itemFavoriteSignal = signal<boolean>(this.itemDetailsSingalModal()?.isFavorite ?? false);
  homePageSignal = this.apiService.homePageSignal;
  auctionConfigSignal = this.apiService.auctionConfigSignal;
  isLoading = this.apiService.isLoadingDetails;

  showCoverTheFee = computed(
      () => this.auctionConfigSignal()?.isCoverTheFeeEnabled
    );

  isAbsenteeBiddingEnabled = computed(
    () => this.apiService.auctionConfigSignal()?.isAbsenteeBiddingEnabled
  );
  protected currency = computed(() => this.apiService.auctionConfigSignal()?.currency ?? '');

  protected showWinningBidText = computed(() => {
    return this.apiService.auctionConfigSignal()?.processor === 'pgf'
  });

  homePageData = computed(() => this.apiService.homePageSignal());

  cardOptions = computed(() => {
    const data = this.authService.creditCardSignal();
    if (!data) return [];

    return data.creditCards.map(card => ({
      label: `${card.type} ****${card.lastDigits}`,
      value: card.id
    }));
  });

  private getItemStatus(item: any): 'upcoming' | 'open' | 'closed' | 'unknown' {
    if (!item?.openingDate || !item?.closingDate) return 'unknown';

    const openingDate = DateTime.fromISO(item.openingDate);
    const closingDate = DateTime.fromISO(item.closingDate);
    const now = DateTime.now();

    if (now < openingDate) return 'upcoming';
    if (now >= openingDate && now < closingDate) return 'open';
    return 'closed';
  }

  itemDateFormat = computed(() => {
    const timezone = this.auctionConfigSignal()?.timezone || 'UTC';
    const closingDate = this.itemDetailsSingalModal()?.closingDate;

    if (!closingDate) return '';

    return this.dateFormatService.formatDateWithTimezone(timezone, closingDate);
  });

  openingDateFormat = computed(() => {
    const timezone = this.auctionConfigSignal()?.timezone || 'UTC';
    const openingDate = this.itemDetailsSingalModal()?.openingDate;

    if (!openingDate) return '';

    return this.dateFormatService.formatDateWithTimezone(timezone, openingDate);
  });

  feeAmountSignal = computed(() => {
    const feeEndpoint = this.paymentService.feeSignal();
    if (!feeEndpoint) return 0;

    return feeEndpoint;

  });

  selectedCard = computed(() => {
    const data = this.authService.creditCardSignal();
    if (!data || data.creditCards.length === 0) return 0;

    const preferredCard = data.creditCards.find(card => card.id === data.preferredCardId);
    return preferredCard ? preferredCard.id : data.creditCards[0].id;
  });

  private getCreditCardErrorMessage = (cardId:number|null|undefined) => {
    if (cardId === null || cardId === undefined) {
      return 'Please select a card to place your bid.'
    }
    return '';
  }

  private readonly themeService = inject(ThemeService);
  themeType: 'bfg' | 'community' = 'bfg';


  constructor(private router: ActivatedRoute, private datePipe: DatePipe, private renderer: Renderer2) {

    effect(() => {
      const data = this.authService.creditCardSignal();
      if (data) {
        this.selectedCardId = this.selectedCard();
      }
    });
  }

  private unlistenMessage?: () => void; // for cleanup

  ngOnDestroy(): void {
    this.recaptchaLoader.unload();
  }

  ngOnInit(): void {
    this.recaptchaLoader.load();

    this.themeType = 'community';
    this.themeService.setPreset(this.themeType);

    if(!this.auctionConfigSignal()){
      this.apiService.getAuctionConfig(this.auctionId ?? 0);
    }


    this.router.paramMap.subscribe(params => {
      this.idItemDetails = Number(params.get('idItem'));
    });

    this.errorLoadItemById = false;

    this.getItemDetails(this.idItemDetails);

    if (this.isAuthenticated().isAuthenticated && !this.authService.creditCardSignal()) {
      this.authService.getCreditCard().subscribe();
    }


    this.authSubscription = this.authService.isAuthenticated$
      .pipe(distinctUntilChanged())
      .subscribe(isAuth => {
        if (isAuth) {
          this.errorLoadItemById = false;
          this.getItemDetails(this.idItemDetails);

        } else {
          this.errorLoadItemById = false;
          this.authService.creditCardSignal.set(null);
          this.isFavorited = false;
          this.getItemDetails(this.idItemDetails);

        }
      });

    // Add window message listener for Unavailable Notification support
    this.unlistenMessage = this.renderer.listen('window', 'message', this.onHandleEpfMessage);

  }

  onTabChange(newTab: string | number  | undefined) {
    if (newTab !== 1) {
      this.askAQuestionControl = '';
      this.responseError = '';
    }
    this.activeTab = Number(newTab);
  }

  onQuestionMark() {
    this.displayQuestionModal = true;
  }

  getItemDetails(itemId: number): void {
    const endpoint = 'items';
    this.apiService.getItemById(endpoint, itemId).pipe(
      tap({
        next: () => {

          const item = this.itemDetailsSingalModal();

          if (item) {

            if (item.auctionId !== 0) {
              this.apiService.getAuctionConfig(item.auctionId).subscribe();
            }

            this.itemsBreadcrumb = [
              { label: 'BiddingForGood', url: this.absoluteMediaUriService.getAbsoluteMediaUri('/auction/biddingforgood.action') },
              this.getCategoryBreadcrumb(item.topLevelCategory ?? ''),
              { label: item.name, url: '/item-details-bc/item/' + item.id }
            ]
            this.customBreadcrumbService.setItems(this.itemsBreadcrumb);

            this.itemModal = item;


            // this.idItemDetails = item!.id;
            this.auctionId = item?.auctionId ?? null;

            if (!this.apiService.homePageSignal()) {
              const endpoint = 'auctions';
              this.apiService.getAuctionHomePageData(endpoint, this.auctionId);
            }


            // // Breadcrumb
            // this.itemsBreadcrumb = [
            //   { label: 'All Items', routerLink: `/item-list/${this.auctionId}` },
            //   { label: item?.name }
            // ]

            if (item?.minimumBid) {
              this.itemMinimunBid = parseFloat(item!.minimumBid.replace(/[^0-9.]/g, ''));;
            }

            if (item?.myMaxBid) {
              this.itemMaximunBid = parseFloat(item!.myMaxBid.replace(/[^0-9.]/g, ''));;
            }

            if (this.isAuthenticated().isAuthenticated && !this.authService.creditCardSignal()) {
              this.authService.getCreditCard().subscribe();
            }

            this.itemType = this.resolveItemType(item);

            // console.log(this.itemType);
            // this.isLoading = false;

            // // console.log('isFavorite', item.isFavorite)

            this.isFavorited = item.isFavorite;
            this.itemFavoriteSignal.set(this.isFavorited);

            //populate gallery
            const mainImage = item.imageUrl?.trim()
              ? (item.imageUrl.startsWith('http') ? item.imageUrl : `${environment.apiUrl}/${item.imageUrl.trim()}`)
              : '/item-default.jpg';
            this.itemModal.imageUrl = mainImage;
            this.selectedImage = mainImage;


            const additionalImages = (item.additionalImagesUrls || [])
              .filter(img => img && img.trim() && img.trim() !== item.imageUrl?.trim())
              .map(img => img.startsWith('http') ? img.trim() : `${environment.apiUrl}/${img.trim()}`);


            setTimeout(() => {
              this.gallery = [mainImage, ...additionalImages];
              this.selectedImage = mainImage;
            }, 0);

            this.bidPlaceholder = this.getBidPlaceholder();

            if (item.isBiddable) {

              this.loadItemBidHistory(item.id);
            }

          }
          this.filteredTab = this.itemModal?.isBiddable
            ? this.tabs
            : this.tabs.filter(t => t.value !== 3);
        },
        error: (error) => {
          this.errorLoadItemById = true;
          console.error('Error fetching item details:', error);
        }
      })
    ).subscribe();
  }

  loadItemBidHistory(itemId: number): void {

    this.oidcSecurityService.getUserData().subscribe(result => {
      if (result) {
        this.userName = result.preferred_username
      } else {
        this.userName = '';
      }
    });

    const endpoint = 'items';
    this.apiService.getItemBidHistory(endpoint, itemId).pipe(

      tap((response) => {
        this.errorLoadingBidHistory = false;

        this.formatBidHistory = response.map(bid => ({
          ...bid,
          placedOn: bid.placedOn ? this.formatDate(bid.placedOn) : bid.placedOn
        }));
      }),

      catchError((error) => {
        console.error('Error fetching bid history:', error);
        this.errorLoadingBidHistory = true;
        return EMPTY;
      }),

      finalize(() => {
        // this.loadingBidHistory = false;
      })

    ).subscribe();
  }


  formatDate(fecha: string): string {

    if (typeof window !== 'undefined') {
      // console.log('formated');
      const cleanedFecha = fecha.replace(/\[.*\]$/, '');
      const date = new Date(cleanedFecha);

      if (isNaN(date.getTime())) {
        throw new Error('Invalid date');
      }
      return this.formatPlacedOnDate = this.datePipe.transform(date, 'MMM dd\'th\', h:mm a')!;
    }

    return '';
  }

  openCaptionModal(caption: string, bid: IItemBidHistory): void {
    // console.log(caption)

    switch (caption) {
      case 'STRAIGHT_BID':
        this.displayStraigthBidModal = true;
        break;
      case 'BELOW_RESERVE':
        this.displayBelowReserveBidModal = true;
        break;
      case 'RESERVE_MET':
        this.displayReserveMetBidModal = true;
        break;
      case 'TIE_WINNER':
        this.tieDetails = bid.tieDetails;
        this.displayTieWinBidModal = true;
        break;
    }
  }

  onHandleEpfMessage = (event: any) => {
    if (event.data !== null) {
      if (event.data.type === "ITEM_UNAVAILABLE") {
        this.visibleEmbedded = false; // this closes modal
        window.location.reload();
      } else if (event.data.type === "EPF_REDIRECT_PARENT_WITH_URL" && event.data.url) {
        console.log('Redirect to Thank You page');
        this.visibleEmbedded = false; // this closes modal
        window.location.replace(event.data.url);
      }
    }
  };


  showLoginIframe() {
    // console.log('here');
    this.getLoginUrl();
  }

  getLoginUrl() {
    let urlHandler = (url: string) => {
      // console.log(url)
      this.loginUrl.set(url);
      this.isShowingLoginIframe.set(true);
    }
    let messageCallback = () => {
      this.isShowingLoginIframe.set(false);
    }
    this.authService.login(urlHandler, messageCallback, false, 0);
  }

  openLoginModal() {
    // console.log("login")
    if (this.auctionId != null) {
      const isTestAuction = this.auctionConfigSignal()?.isTestAuction;
      this.authService.openLoginModal(
        LOGIN_TYPE_TICKETS,
        this.embeddedPaymentLoad,
        this.auctionId,
        this.embeddedPaymentLoad,
        '',
        { hideGuestOption: isTestAuction }
      );
    }
  }

  openLoginModalFavorite(fun?: () => void) {
    if (this.auctionId != null) {
      this.authService.openLoginModal(LOGIN_TYPE_TOPBAR, fun, this.auctionId);
    }
  }

  embeddedPaymentLoad = (): void => {

    const lineItems: ILineItems[] = [
      { id: this.idItemDetails, type: 3, quantity: this.quantity, donationAmount: 0.0 }
    ];

    if (this.auctionConfigSignal()?.isTestAuction) {
      this.paymentService.postTestPurchase(this.auctionId!, lineItems, undefined, undefined, undefined, true).subscribe({
        next: () => {
          this.route.navigate(['/payment-successful']);
        },
        error: (error) => {
          console.error('Error processing test purchase:', error);
        }
      });
      return;
    }

    this.paymentService.postEmbeddedPayment(this.auctionId!, lineItems, undefined, undefined, undefined, true).subscribe({
      next: (token) => {
        this.openEmbeddedPayment(token);
      },
      error: (error) => {
        console.error('Error al obtener el token:', error);
      }
    })
  }

  openEmbeddedPayment(token: string) {
    this.token = token;
    this.visibleEmbedded = true;
  }

  getBidPlaceholder(): string {
    const format = (amount: number) => `$${amount} ${this.currency()}`;

    const maxBid = Number(this.itemMaximunBid);
    const minBid = Number(this.itemMinimunBid);

    if (this.itemModal?.isLeader && maxBid >= minBid) {
      this.myBidLabel = 'Increase my bid to:';
      return `${format(maxBid + 1)} Next Minimum Bid`;
    }

    if (this.itemModal?.isLeader && maxBid < minBid) {
      this.myBidLabel = 'Increase my bid to:';
      return `${format(minBid)} Next Minimum Bid`;
    }

    this.myBidLabel = 'My Bid:';
    return `${format(minBid)} Next Minimum Bid`;

  }

  selectedCardName(): string | null {
    const selected = this.cardOptions().find(card => card.value === this.selectedCardId);
    return selected?.label || '';
  }

  protected onClickBack() {
    this.showConfirmTemplate = false;
    this.showLowBidError = false;
    this.showBidError = false;
    this.errorMessage = "";
  }

  protected validateBid(): boolean {
    let valid = true;
    valid = valid && this.validateWholeNumber(this.selectedBid);
    valid = valid && this.errorLowBid();
    valid = valid && this.validateCreditCard();

    if (valid) {
      this.getFeeEndpoint();
      this.showConfirmTemplate = true;
    }
    return valid;
  }

  private validateCreditCard = () => {
    this.creditCardErrorMessage = this.getCreditCardErrorMessage(this.selectedCardId);
    return this.creditCardErrorMessage === '';
  }

  private validateWholeNumber(value: string): boolean {
    try {
      const regex = /^[0-9]+$/;
      return regex.test(value);
    } catch (error) {
      console.error("Error validating whole number:", error);
    }
    return false;
  }

  private errorLowBid() {
    if (this.selectedBid == null || this.selectedBid === '') {
      return false;
    }

    const bid = Number(this.selectedBid);

    if (this.itemMaximunBid != null && bid <= this.itemMaximunBid) {
      this.showMaxBidError = true;
      return false;
    } else if (this.itemMinimunBid > bid) {
      this.showLowBidError = true;
      return false;
    }

    return true;

  }

  // onCoverFeeChange(value: boolean) {
  //   if (value) {
  //     this.getFeeEndpoint();
  //   } else {
  //     this.feeSignal.set(0);
  //   }
  // }

  getFeeEndpoint() {
    const coverFeeData: IFeeRequest = {
      auctionId: this.auctionId!,
      amount: Number(this.selectedBid),
      purchaseType: 3
    }

    this.paymentService.getFee(coverFeeData).subscribe({
      next: (response) => {
        this.feeSignal.set(response);
      }
    });

  }

  protected placeABid() {

    this.postBiddingLoading = true;

    const biddingData: IBiddingRequest = {
      selectedCard: this.selectedCardId,
      bidType: this.selectedBidOption,
      amount: Number(this.selectedBid),
      coverTheFee: this.coverFeeConfirm,
      isFromBidderCommunity: true
    }

    this.biddingService.postBidding(this.idItemDetails, biddingData).subscribe({
      next: (response: string) => {
        try {
          const parsed = JSON.parse(response);
          this.bidResponseSignal.set(parsed.status ?? '');

          this.showBidStatus = true;
          this.showConfirmTemplate = false;
          this.getItemDetails(this.idItemDetails);
          this.postBiddingLoading = false;
          this.postBiddingError = false;

          // this.bidCompleted.emit();

        } catch (error) {
          console.error('error catch:', error);
          this.bidResponseSignal.set('');
          this.postBiddingLoading = false;
          this.postBiddingError = true;
        }
      },
      error: (err: HttpErrorResponse) => {


        this.postBiddingLoading = false;
        this.postBiddingError = true;

        if (err.status === 500 || err.status === 401) {
          this.route.navigate(['/error/internal']);

          return;
        } else {

          try {
            const parsed = JSON.parse(err.error);
            this.errorMessage = parsed.message;
          } catch {
            console.error('Error parsing error message');
          }
        }
      }
    });
  }

  toggleFavorite(): void {
    if (this.isFavorited) {
      this.removeItemFavorite();
    }
    else {
      this.itemFavorite();
    }
  }

  itemFavorite = () => {

    this.favoriteService.putFavorite(this.idItemDetails).subscribe({
      next: (reponse) => {
        // console.log('favorite response', reponse)
        this.isFavorited = true;
        this.itemFavoriteSignal.set(true);

      },
      error: (error) => {
        console.error('Favorite error:', error);
      }
    })
  }
  removeItemFavorite() {

    this.favoriteService.deleteFavorite(this.idItemDetails).subscribe({
      next: (reponse) => {
        // console.log('favorite responde', reponse)
        this.isFavorited = false;
        this.itemFavoriteSignal.set(false);

      },
      error: (error) => {
        console.error('Favorite error:', error);
      }
    })
  }

  resetVariables() {
    this.showConfirmTemplate = false;
    this.showLowBidError = false;
    this.showBidStatus = false;
    this.showBidError = false;
    this.errorMessage = "";
    this.bidResponseSignal.set('');
    this.selectedBidOption = 'PROXY';
    this.selectedBid = '';
    this.coverFeeConfirm = false;
  }
  private resolveItemType(item: any): 'buy' | 'bid' | 'buy-bid' | 'event' | 'upcoming' | 'closed' | 'sold' {
    const status = this.getItemStatus(item);

    if (status === 'closed') return 'closed';
    if (status === 'upcoming' && item.biddingType !== 'LIVE_ONLY') return 'upcoming';
    if (item.biddingType === 'LIVE_ONLY') return 'event';
    if (item.biddingType === 'BUY_NOW_ONLY' && !item.isBuyable && !item.isBiddable) return 'sold';
    if (!item.isBuyable && !item.isBiddable && item.quantityAvailable === 0 && item.numberSold === 1) return 'sold';
    if (item.isBuyable && item.isBiddable) return 'buy-bid';
    if (item.isBuyable) return 'buy';
    if (item.isBiddable) return 'bid';
    return 'event';
  }

  // Question tab
  onAskAQuestion() {
    if (this.askAQuestionControl && this.askAQuestionControl.trim() !== '') {
      if (this.isAuthenticated().isAuthenticated) {
        this.postAsqkAQuestion()
      } else {
        this.openLoginModalFavorite(this.postAsqkAQuestion);
      }
    } else {
      this.responseError = 'Question is a required field';
      return;
    }
  }

  onQuestionChange() {
    if (this.askAQuestionControl.trim() !== '')
      this.responseError = '';
  }

  postAsqkAQuestion = (): void => {
    this.oidcSecurityService.getUserData().subscribe(result => {
      if (result) {
        this.userEmail = result.email ?? '';
      }
    });

    const askAQuestionObj: IAskAQuestionRequest = {
      question: this.askAQuestionControl,
      email: this.userEmail ?? 'test@gmail.com'
    };

    this.recaptchaV3Service.execute(environment.siteKey, 'ask_question', (token: string) => {

      const recaptchaDom = document.querySelector('.grecaptcha-badge') as HTMLElement;

      recaptchaDom.style.visibility = 'visible';

      this.apiService.postAskAQuestion(this.idItemDetails, askAQuestionObj, token).subscribe({
        next: (response) => {
          this.messageService.success(`Your question has been sent to the auction team. They will contact you at ${this.userEmail} within a few days. `);
        },
        error: (err) => {
          let errorMsg = 'unknown error';

          if (typeof err.error === 'string') {
            try {
              const parsed = JSON.parse(err.error);
              errorMsg = parsed.message || errorMsg;

            } catch (e) {
              errorMsg = err.error;
            }
          }
          else if (err.error && err.error.errorMessage) {
            errorMsg = err.error.errorMessage;
          }

          this.messageService.error(errorMsg || 'unknown error');
        }
      });

      setTimeout(() => {
        recaptchaDom.style.visibility = 'hidden';
        this.askAQuestionControl = '';
      }, 3000);
    });
  }

  onAddCreditCard() {
    this.modalService.openModal('credit-card', CreditCardInformationComponent, {
      width: '500px',
      modal: true,
      closable: true,
      dismissableMask: true,
      contentStyle: {
        padding: '1.5rem',
        maxHeight: '90vh',
        overflowY: 'auto'
      },
      breakpoints: {
        '960px': '80vw',
        '640px': '95vw'
      },
      data: {
        isCommunity: true
      }
    });
  }

  openReserveModal() {

    this.modalService.openModal('has-reserve-item', BelowReserveComponent, {
      width: '500px',
      modal: true,
      // closable: true,
      dismissableMask: true,
      contentStyle: {
        padding: '1.5rem',
        maxHeight: '90vh',
        overflowY: 'auto'
      },
      breakpoints: {
        '960px': '80vw',
        '640px': '95vw'
      }
    });
  }

  onModalExplanationClose() {
    switch (this.activeCaption) {
      case 'STRAIGHT_BID':
        this.displayStraigthBidModal = false;
        break;
      case 'BELOW_RESERVE':
        this.displayBelowReserveBidModal = false;
        break;
      case 'RESERVE_MET':
        this.displayReserveMetBidModal = false;
        break;
      case 'TIE_WINNER':
        this.displayTieWinBidModal = false;
        break;
    }
  }

  onModalClose() {
    this.displayQuestionModal = false;
  }

  getCategoryBreadcrumb(cat: string): ICustomMenuItem {
    return {
      label: cat.toLowerCase().replace(/^\w/, c => c.toUpperCase()),
      url: this.getCatRouterLink(cat).toString(),
      queryParams: this.getCatQueryParams(cat)
    }
  }

  getCatQueryParams(cat: string) {
    return cat === 'Closing Soon' ? { sort: 'ending' } : undefined;
  }

  getCatRouterLink(cat: string) {
    if (cat === 'Unique') {
      cat = 'experiences';
    } else if (cat === 'Closing Soon') {
      cat = 'closing';
    }
    return ['/items/' + cat.toLowerCase().replace(/\s+/g, '-')];
  }

  isAmountEstimatedValue(value: string): boolean {
    const numeric = value.replace(/[^0-9.-]+/g, '');
    return numeric.trim() !== '' && !isNaN(Number(numeric));
  }

  protected baseShareUrl = computed(() => {
    if (isPlatformBrowser(this.platformId) && {type: 'itemcommunity', id:this.idItemDetails}) {
      const { type, id } = {type: 'itemcommunity', id:this.idItemDetails};
      return `${environment.apiUrl}/v3/social-media-sharing/${type}/${id}`;
    }
    return "";
  })


  protected openPopupCenter(pageURL: string, title: string, w: number, h: number) {
    if (isPlatformBrowser(this.platformId)) {
      var windowSize = {
        width: w,
        height: h
      };
      var windowLocation = {
        left: ((window.screen.availWidth / 2) - (windowSize.width / 2)),
        top: ((window.screen.availHeight / 2) - (windowSize.height / 2))
      };
      window.open(pageURL, title, 'width=' + w + ', height=' + h + ', left=' + windowLocation.left + ', top=' + windowLocation.top);
    }
  }

  protected facebookShareUrl = computed(() => {
    if (isPlatformBrowser(this.platformId)) {
      const url = this.baseShareUrl();
      return `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
    }
    return "";
  })


  protected twitterShareUrl = computed(() => {
    if (isPlatformBrowser(this.platformId)) {
      const url = this.baseShareUrl();
      return "https://twitter.com/intent/tweet?url=" + encodeURIComponent(url);
    }
    return "";
  })

  protected linkedinShareUrl = computed(() => {
    if (isPlatformBrowser(this.platformId)) {
      const url = this.baseShareUrl();
      return "https://www.linkedin.com/shareArticle?mini=true&url=" + encodeURIComponent(url);
    }
    return "";
  })

  protected copyUrl = computed(()=> {
    if (isPlatformBrowser(this.platformId)) {
      const url = this.baseShareUrl();
      return url;
    }
    return "";
  })

  protected onCopyUrl() {
    this.messageService.success('URL copied to clipboard!');
  }


}
